package games.polyclub.website.frontend.store.layout

import adminlte.treeview.Treeview
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.classSet
import games.polyclub.website.frontend.store.context.useCart
import games.polyclub.website.frontend.store.hooks.useUserPreferences
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import jquery.jQuery
import react.Props
import react.createRef
import react.dom.aria.AriaRole
import react.router.dom.Link
import react.useEffect
import web.html.HTMLUListElement

val TopRightBar = SFC<Props> { _ ->
    val rootTreeViewRef = createRef<HTMLUListElement>()
    useEffect(rootTreeViewRef) {
        jQuery(rootTreeViewRef.current).Treeview("init")
    }
    val userPrefsCtx = useUserPreferences()
    val cartCtx = useCart()
    ul("navbar-nav ml-auto") {
        ref = rootTreeViewRef
        /*<li class="nav-item">
            <a class="nav-link" data-widget="navbar-search" href="#" role="button">
                <i class="fas fa-search"></i>
            </a>
            <div class="navbar-search-block">
                <form class="form-inline">
                    <div class="input-group input-group-sm">
                        <input class="form-control form-control-navbar" type="search" placeholder="Search"
                               aria-label="Search">
                        <div class="input-group-append">
                            <button class="btn btn-navbar" type="submit">
                                <i class="fas fa-search"></i>
                            </button>
                            <button class="btn btn-navbar" type="button" data-widget="navbar-search">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </li>*/
        /*<li class="nav-item dropdown">
            <a class="nav-link" data-toggle="dropdown" href="#">
                <i class="far fa-comments"></i>
                <span class="badge badge-danger navbar-badge">3</span>
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <a href="#" class="dropdown-item">

                    <div class="media">
                        <img src="dist/img/user1-128x128.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">
                        <div class="media-body">
                            <h3 class="dropdown-item-title">
                                Brad Diesel
                                <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                            </h3>
                            <p class="text-sm">Call me whenever you can...</p>
                            <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
                        </div>
                    </div>

                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">

                    <div class="media">
                        <img src="dist/img/user8-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
                        <div class="media-body">
                            <h3 class="dropdown-item-title">
                                John Pierce
                                <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                            </h3>
                            <p class="text-sm">I got your message bro</p>
                            <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
                        </div>
                    </div>

                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">

                    <div class="media">
                        <img src="dist/img/user3-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
                        <div class="media-body">
                            <h3 class="dropdown-item-title">
                                Nora Silvester
                                <span class="float-right text-sm text-warning"><i class="fas fa-star"></i></span>
                            </h3>
                            <p class="text-sm">The subject goes here</p>
                            <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
                        </div>
                    </div>

                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item dropdown-footer">See All Messages</a>
            </div>
        </li>*/
        /*<li class="nav-item dropdown">
            <a class="nav-link" data-toggle="dropdown" href="#">
                <i class="far fa-bell"></i>
                <span class="badge badge-warning navbar-badge">15</span>
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span class="dropdown-item dropdown-header">15 Notifications</span>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">
                    <i class="fas fa-envelope mr-2"></i> 4 new messages
                    <span class="float-right text-muted text-sm">3 mins</span>
                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">
                    <i class="fas fa-users mr-2"></i> 8 friend requests
                    <span class="float-right text-muted text-sm">12 hours</span>
                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">
                    <i class="fas fa-file mr-2"></i> 3 new reports
                    <span class="float-right text-muted text-sm">2 days</span>
                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
            </div>
        </li>*/
        li("nav-item") {
            Link("nav-link") {
                ref = cartCtx.cartButtonRef
                to = LoggedSitemap.CART.path
                role = AriaRole.button
                with(LoggedSitemap.CART.icon!!) {
                    renderIcon()
                }
                val items = cartCtx.selectedProducts.sumOf { it.quantity }
                if (items > 0) {
                    span("badge badge-primary navbar-badge") {
                        +items.toString()
                    }
                }
            }
        }
        TopBarUser()
        li("nav-item") {
            a("nav-link") {
                onClick = { ev ->
                    ev.preventDefault()
                    userPrefsCtx.changePreferences { current ->
                        current.copy(darkMode = !current.darkMode)
                    }
                }
                role = AriaRole.button
                i("fa") {
                    classSet += if (userPrefsCtx.preferences.darkMode) {
                        "fa-moon"
                    } else {
                        "fa-sun"
                    }
                }
            }
        }
        /*li("nav-item") {
            a("nav-link") {
                pData("widget", "control-sidebar")
                pData("controlsidebar-slide", "true")
                href = "#"
                role = AriaRole.button
                i("fas fa-th-large")
            }
        }*/
    }
}
